import MetaModel from "../../../../../Global/Models/Pagination/MetaModel";
import PersonalityQuizParticipationModel from "./PersonalityQuizParticipationModel";

export default class PersonalityQuizUserParticipationsModel {
  public meta: MetaModel = new MetaModel();
  public data: PersonalityQuizParticipationModel[] = [];
}
